import { AbstractCommand } from 'src/models/command';
import { Memo } from 'src/models/memo';

import { formatDate } from 'src/util/date';

class SaveMemoCommand extends AbstractCommand {
	readonly name = 'IFS_IDO_IdoActivity_Command_Commands_SaveIdoActivity';

	public constructor(memo: Memo) {
		super();
		this.parameters = {
			aggregateId: memo.aggregateId,
			alert: memo.alarm,
			author: memo.authorId,
			communicationType: memo.communicationTypeId,
			contactPerson: memo.contactPersonId,
			content: memo.content,
			date: formatDate(parseInt(memo.timestamp) * 1000, 'YYYY-MM-DD'),
			duration: memo.duration,
			time: formatDate(parseInt(memo.timestamp) * 1000, 'H:mm'),
			title: memo.title,
		};
	}
}

export { SaveMemoCommand };
